<template>
  <div style="margin-left: 20px; margin-top: 20px">
    <el-row>
      <el-col :span="12">
        <form-section :title="steps[currentStep.index].subtitle">
          <el-button class="allow-button" @click="completeStep">
            complete step
          </el-button>
        </form-section>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import FormSection from '../../components/form/FormSection'

export default {
  name: 'StepThree',

  components: {
    FormSection
  },

  props: {
    currentStep: {
      type: Object,
      required: true
    },

    steps: {
      type: Array,
      required: true
    }
  },

  methods: {
    completeStep() {
      this.$emit('complete-step', this.currentStep.index)
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/common/tests/page/StepThree.vue